"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @typedef {{[key: string]: string|number|boolean}} AppearanceSet
 * @typedef {AppearanceSet} VariantProp
 */
var _default = exports.default = {
  /**
   * 'variant' is an optional object prop on all themable components.
   *
   * Contains an object with keys that correspond to the current component theme's allowed
   * appearances and values that correspond to the allowed values of that component.
   *
   * Since the particular keys and values depend on which theme is currently active,
   * the exact shape of variant props is not enforced using PropTypes.
   */
  propType: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))
};